import { PropTypeMediaEntry } from "fleet/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { ContentArchived } from "ui/content-archived";

import { ContentPreview } from "./content-preview";
import { EditContentForm } from "./edit-content-form";

class ContentEditor extends React.PureComponent {
  static get propTypes() {
    return {
      categories: PropTypes.arrayOf(PropTypes.string),
      getChildState: PropTypes.func,
      getConfig: PropTypes.func.isRequired,
      hideFullscreen: PropTypes.func,
      mediaEntry: PropTypeMediaEntry,
      showFullscreen: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      categories: [],
      getChildState: () => {},
      hideFullscreen: () => {},
      showFullscreen: () => {},
    };
  }

  render() {
    const {
      categories,
      getChildState,
      getConfig,
      hideFullscreen,
      mediaEntry,
      showFullscreen,
    } = this.props;
    const { mimeType, name, type, url } = mediaEntry;

    const config = getConfig(type, mimeType);
    const { excludeFields, readOnlyFields } = config;

    return (
      <div className="content-editor">
        <ContentPreview
          type={type}
          url={url}
          mimeType={mimeType}
          name={name}
          hideFullscreen={hideFullscreen}
          showFullscreen={showFullscreen}
        />
        <ContentArchived mediaEntry={mediaEntry} />
        <EditContentForm
          mediaEntry={mediaEntry}
          getState={getChildState}
          excludeFields={excludeFields}
          categories={categories}
          readOnlyFields={readOnlyFields}
        />
      </div>
    );
  }
}

export { ContentEditor };
